import { incrementTelemetry } from 'core-events/actions';
import noop from 'lodash/noop';
import React, { JSX, useState } from 'react';

import Dropdown from '../../../../components/components/elements/Dropdown';
import { ContentTypes, ContentTypesWithSnapshots } from './ContentTypes';

import './navSearchDropdown.css';

const COMPACT_BUTTON_CLASSES =
    'flex justify-center items-center bg-gray-900 hover:bg-black z-10 whitespace-nowrap text-sm font-semibold cursor-pointer rounded-full h-8 px-4 text-white gap-1.5 border border-solid border-gray-900';

// Bare-text treatment used when the conversational-search toggle is present in the
// bar: semibold 16px label + 16px chevron, no dark pill, rounded-lg focus ring.
const BARE_TEXT_BUTTON_CLASSES =
    'flex justify-center items-center bg-transparent z-10 whitespace-nowrap text-base font-semibold cursor-pointer rounded-lg h-8 px-2 text-gray-900 gap-1.5 focus-visible:ring-2';
const BARE_TEXT_CHEVRON_CLASSES = 'w-4 h-4 fill-current';

export default function NavSearchDropdown({
    onChange = noop,
    value = '',
    useSnapshots = false,
    compact = false,
    bareText = false,
}: {
    onChange: (value: string) => void;
    value: string;
    useSnapshots?: boolean;
    compact?: boolean;
    bareText?: boolean;
}): JSX.Element {
    const [isOpen, setIsOpen] = useState(false);
    const options = useSnapshots ? ContentTypesWithSnapshots : ContentTypes;

    const dropdownToggle = () => {
        setIsOpen((prev) => !prev);
    };

    const dropdownClose = () => {
        setIsOpen(false);
    };

    const dropdownSelect = (value: string) => {
        onChange(value);
        void incrementTelemetry(`nav.search.${value}`);
        dropdownClose();
    };

    return (
        <Dropdown
            options={options}
            value={value}
            isOpen={isOpen}
            onToggle={dropdownToggle}
            onClose={dropdownClose}
            onSelect={dropdownSelect}
            buttonClassName={compact ? (bareText ? BARE_TEXT_BUTTON_CLASSES : COMPACT_BUTTON_CLASSES) : undefined}
            chevronClassName={compact && bareText ? BARE_TEXT_CHEVRON_CLASSES : undefined}
            hideLabelIcon={compact}
        />
    );
}
